'use strict';

import 'es6-promise/auto';
import '../utils/bem-plugins';

import advert from '../adverts/advert';
import backToTop from '../components/back-to-top';
import footerNav from '../components/structure/footer-nav';
import horizontalNav from '../components/structure/horizontal-nav';
import mobileNav from '../components/structure/mobile-nav';
import siteNav from '../components/structure/site-nav';
import analytics from '../utils/analytics';
import logger from '../utils/logger';
import foundationLoader from '../utils/foundation-loader';
import config from '../utils/config';
import debugHelper from '../utils/debug-helper';
import permutive from '../utils/permutive';
import screenSizeWatcher from '../watchers/screen-size-watcher';
import scrollWatcher from '../watchers/scroll-watcher';
import newsletterSignup from '../components/newsletter-signup';
import admiralTargeting from '../utils/admiral-targeting';
import covatic from '../utils/covatic';

function initConfig() {
	if (typeof config === 'undefined') {
		window.alert('The parkersConfig JSON object must be defined before parkers.js is loaded.');
	} else {
		logger.info('Parkers config', config);
	}
}

function foundationLoadedCallback() {
	logger.debug('Foundation load callback after ' + logger.secondsSincePageStart());

	debugHelper.init();
	footerNav.init();
	horizontalNav.init();
	mobileNav.init();
	siteNav.init();
	backToTop.init();
	newsletterSignup.init();

	analytics.initClickTracking();
}

export function baseInit(foundationPlugins) {
	logger.debug('Initialising app - after ' + logger.secondsSincePageStart());

	foundationLoader.loadFoundation(foundationLoadedCallback);

	if (Array.isArray(foundationPlugins)) {
		foundationLoader.addPlugins(foundationPlugins);
	}

	initConfig();

	scrollWatcher.start();
	screenSizeWatcher.start();

	screenSizeWatcher.onChange(function () {
		$('#offCanvasSearch').foundation('close');
		$('#offCanvasRight').foundation('close');
	});
}

export function baseInitGpt(adConfig) {
	advert.init(adConfig);

	admiralTargeting.init();
	permutive.init();
	covatic.init();
}

export function baseSetupHeroSkin(options) {
	advert.setupHeroSkin(options);
}
